<template>
  <div class="d-flex flex-column min-vh-100">
    <Header />
    <div class="flex-fill d-flex flex-column">
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from './header'
import Footer from './footer'
export default {
  name: 'AppMain',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      isSidebarCollapse: false
    }
  },
  computed: {},
  methods: {
    /**
     * Sidebar子元件getEmitedValue
     */
    getSidebarCollapse(data) {
      this.isSidebarCollapse = data
    }
  }
}
</script>
